<template>
  <div class="wrapper">
    <div class="ccui-app-container">
      <!--评标结果-->
      <!--table表格区域Begin-->
      <div class="ccui-multifunctional-table-wrapper">
        <listBaseTable
          :tableName="tableName"
          :showCheckBox="false"
          :showOp="false"
          :data="tableData"
          :cellStyle="cellStyle"
          :pageNo.sync="pageNo"
          :pageSize.sync="pageSize"
          :pageTotal="pageTotal"
          :fixedTableThead="fixedTableThead"
          :unfixedTableThead="unfixedTableThead"
          border
          @handleList="handleList"
          @select-all="handleCheckAllChange"
          @select="handleCheckChange"
          @selection-change="handleSelectionChange"
        >
          <template slot="noticeStatusName" slot-scope="{ row }">
            <span>{{
              row.noticeStatus == "3"
                ? $t("page.content.alreadyEnded")
                : $t("page.content.inThePublicity")
            }}</span>
          </template>
          <!--列表中的插槽Begin-->
          <template slot="title" slot-scope="{ row }">
            <el-button
              class="column-btn-ellipsis"
              size="mini"
              type="text"
              @click="check(row)"
            >
              {{ row.noticeTitle }}
            </el-button>
          </template>
          <!--列表中的插槽End-->
        </listBaseTable>
      </div>
      <!--table表格区域End-->
    </div>
  </div>
</template>

<script>
import { mixinListCommon } from "@/mixins/mixin-common/mixin-list";
import { commonTableWidth } from "@/setting/setting";
import { listSupBidNotice } from "@/app/shop/api/shoppingSP";
import Cookies from "js-cookie";
import moment from "moment";
// import $t from "@/app/shop/utils/translateUtil";
export default {
  name: "noticeViewAllList",
  mixins: [mixinListCommon],

  props: {
    noticeType: {
      type: Number,
      default: 3 //公告类型
    },
    noticeStatus: {
      type: String,
      default: ""
    },
    noticeTime: {
      type: Array,
      default: () => []
    },
    noticeTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      tableName: this.tableList.viewMoreList, // 默认的tableName 工程中唯一
      isSelection: false,
      formData: {},
      statusOptions: [
        {
          //公示中
          dicKey: "2",
          dicValue: this.$t("page.content.inThePublicity")
        },
        {
          //已结束
          dicKey: "3",
          dicValue: this.$t("page.content.alreadyEnded")
        }
      ],
      formDataSearch: {},
      tableData: [],
      unfixedTableTheadAll: [],
      fixedTableThead: [],
      unfixedTableThead: Object.freeze([
        {
          label: this.$t("page.content.serialNo"),
          prop: "id",
          type: "index",
          width: this.$TW.serialNoWidth,
          checked: true
        },
        {
          label: this.$t("page.content.title"),
          prop: "noticeTitle",
          width: 500,
          checked: true,
          slot: "title"
        },
        {
          //状态
          label: this.$t("page.content.status"),
          prop: "noticeStatusName",
          width: 150,
          checked: true,
          slot: "noticeStatusName"
        },
        {
          label: this.$t("page.content.publishTime"),
          prop: "noticeStartTime",
          width: commonTableWidth.dateTimeWidth,
          checked: true
        }
      ]),
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      supInfo: this.$store.state.user.supInfo || {}
    };
  },
  methods: {
    // $t, // 移植代码存在国际化方案临时解决
    initData() {
      this.pageNo = 1;
      this.pageSize = 10;
      this.pageTotal = 0;
      this.formData = {};
      this.formDataSearch = {};
      this.tableName = this.tableList.viewMoreList;
    },
    handleList() {
      // 分页操作列表
      this.getNoticeList();
    },
    getNoticeList() {
      let supCodeList = [];
      if (this.supInfo.getSupInfoByLoginInfoRspBOList) {
        supCodeList = this.supInfo.getSupInfoByLoginInfoRspBOList.map(item => {
          return item.supCode;
        });
      }
      let param = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        noticeType: this.noticeType,
        noticeStatusEndFlag: "1", //是否查询已结束的公告 0-否 1-是
        isShowPageLoading: true,
        supCodeList: supCodeList,
        noticeStatus: this.noticeStatus,
        noticeTitle: this.noticeTitle ? this.noticeTitle : null
      };
      if (
        Cookies.get("language") !== undefined &&
        Cookies.get("language") !== "zh-cn"
      ) {
        param.overseasSupFlag = 1;
      }
      if (this.noticeTime && this.noticeTime.length !== 0) {
        this.formDataSearch.noticeTimeStart = this.noticeTime[0] + " 00:00:00";
        this.formDataSearch.noticeTimeEnd = this.noticeTime[1] + " 23:59:59";
      } else {
        this.formDataSearch.noticeTimeStart = null;
        this.formDataSearch.noticeTimeEnd = null;
      }
      Object.assign(param, this.formDataSearch);
      this.$delete(param, "noticeTime");
      listSupBidNotice(param).then(res => {
        if (res.data.code === "0") {
          this.tableData = res.data.data.rows.map(item => {
            item.noticeStartTime = item.noticeStartTime
              ? moment(item.noticeStartTime).format("YYYY-MM-DD HH:mm")
              : "";
            return item;
          });
          this.pageTotal = res.data.data.recordsTotal;
        }
      });
    },
    search(searchData) {
      this.pageNo = 1;
      this.formDataSearch = searchData;
      this.getNoticeList();
    },
    //查看
    check(row) {
      let url = this.$router.resolve({
        path: "/viewNoticeSimpleDetail",
        query: {
          type: this.noticeType,
          schemeId: row.schemeId,
          schemeName: row.schemeName,
          schemeCode: row.schemeCode,
          noticeId: row.noticeId,
          opUnitName: row.opUnitName,
          opUnitId: row.opUnitId,
          purchaseType: row.purchaseType
        }
      });
      window.open(url.href, "_blank");
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    },
    handleCheckAllChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleCheckChange(arr) {
      this.isSelection = arr.length !== 0;
    },
    handleSelectionChange(arr) {
      this.isSelection = arr.length !== 0;
    }
  },
  mounted() {
    this.getNoticeList();
  },
  watch: {
    noticeStatus: {
      handler(val) {
        this.pageNo = 1;
        this.getNoticeList();
      }
    },
    noticeTime: {
      handler(val) {
        this.pageNo = 1;
        this.getNoticeList();
      }
    },
    noticeTitle: {
      handler(val) {
        this.pageNo = 1;
        this.getNoticeList();
      }
    }
  }
};
</script>

<style scoped lang="scss">
/deep/.el-searchs {
  display: none;
  .icon-ccui-downdown {
    display: none;
  }
}
/deep/.ccui-search-wrapper {
  display: none;
}
/deep/.ccui-advanced-search-wrapper {
  .el-search .el-searchs-bottom .el-form-item .el-form-item__label {
    min-width: 0 !important;
    width: auto !important;
  }
}
/deep/.el-form-item__content {
  margin-right: 20px;
}
/deep/.el-col-8 {
  width: 28%;
}
/deep/.el-col-24 {
  width: 170px;
}
/deep/.icon-ccui-downdown {
  display: none;
}
</style>
